import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { ConvertToKLacCr, ConvertToKLacCr10K } from "../../util/common";

function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

function fix_dpi(canvas) {
  // let dpi = window.devicePixelRatio;
  let dpi = 2;
  let multiplier = 1;
  let os = getOS();

  if (os == "Windows") multiplier = 1.6;
  //create a style object that returns width and height
  let style = {
    height() {
      return (
        +multiplier *
        getComputedStyle(canvas).getPropertyValue("height").slice(0, -2)
      );
    },
    width() {
      return getComputedStyle(canvas).getPropertyValue("width").slice(0, -2);
    },
  };
  canvas.setAttribute("width", 600);
  canvas.setAttribute("height", 600);
  // canvas.setAttribute("height", style.height() * dpi);
}

const Animation = ({ expectedReturn, selectedCard }) => {
  const { country_code } = useSelector((state) => state.layout);
  const canvasRef = useRef(null);
  const draw = (ctx, percentage, amount, frameCount) => {
    var gradientColors = [];
    gradientColors.push("#E14084");
    gradientColors.push("#54B5BB");
    gradientColors.push("#3454FA");

    var xc = 300;
    var yc = 320;
    var r = 220;
    var circleWidth = 100;

    var partLength = (2 * Math.PI * percentage) / gradientColors.length;
    var start = 0;
    var gradient = null;
    var startColor = null,
      endColor = null;

    for (var i = 0; i < gradientColors.length; i++) {
      startColor = gradientColors[i];
      endColor = gradientColors[(i + 1) % gradientColors.length];

      // x start / end of the next arc to draw
      var xStart = xc + Math.cos(start) * r;
      var xEnd = xc + Math.cos(start + partLength) * r;
      // y start / end of the next arc to draw
      var yStart = yc + Math.sin(start) * r;
      var yEnd = yc + Math.sin(start + partLength) * r;

      ctx.beginPath();

      gradient = ctx.createLinearGradient(xStart, yStart, xEnd, yEnd);
      gradient.addColorStop(0, startColor);
      gradient.addColorStop(1.0, endColor);

      ctx.strokeStyle = gradient;
      ctx.arc(xc, yc, r, start, start + partLength);
      ctx.lineWidth = circleWidth;
      ctx.stroke();
      ctx.closePath();

      start += partLength;
    }

    // x start / end of the next arc to draw
    var xStart = xc + Math.cos(2 * Math.PI * percentage) * r;
    var xEnd = xc + Math.cos(2 * Math.PI) * r;
    // y start / end of the next arc to draw
    var yStart = yc + Math.sin(2 * Math.PI * percentage) * r;
    var yEnd = yc + Math.sin(2 * Math.PI) * r;

    ctx.beginPath();

    ctx.strokeStyle = "#FFFFFF";
    ctx.arc(xc, yc, r, 2 * Math.PI * percentage, 2 * Math.PI);
    ctx.lineWidth = circleWidth;
    ctx.stroke();
    ctx.closePath();

    //Coordinate for placement of text at central position.

    var x1 = xc + r * Math.cos(-((2 * Math.PI * (1 - percentage)) / 2));
    var y1 = yc + r * Math.sin(-((2 * Math.PI * (1 - percentage)) / 2));

    var x2 =
      xc + r * Math.cos(Math.PI + -((2 * Math.PI * (1 - percentage)) / 2));
    var y2 =
      yc + r * Math.sin(Math.PI + -((2 * Math.PI * (1 - percentage)) / 2));

    ctx.font = "26px Inter";
    ctx.fillStyle = "#000000";
    ctx.textAlign = "center";
    ctx.fillText(ConvertToKLacCr10K(amount, country_code), x1, y1);

    ctx.font = "26px Inter";
    ctx.fillStyle = "#FFFFFF";
    ctx.textAlign = "center";
    ctx.fillText(
      ConvertToKLacCr10K(
        (amount * percentage) / (1 - percentage),
        country_code
      ),
      x2,
      y2
    );
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    fix_dpi(canvas);
    const context = canvas.getContext("2d");
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    // const context = canvas.getContext("2d").scale(ratio, ratio);

    let cardPriceINR = selectedCard * 80;
    let totalPrice = cardPriceINR + expectedReturn;
    let percent = expectedReturn / totalPrice;
    draw(context, percent, Math.round(cardPriceINR));
  });

  return <canvas style={{ height: "300px" }} ref={canvasRef} />;
};

export default Animation;
